export const GERRY_AVATAR = "https://static.prod-images.emergentagent.com/jobs/2429ed2b-a893-4473-8b2e-2593750e3655/images/4b8bf7ab25b9d80057b361f33d446357bff4abda8b91b3c16dff2988dc9e02b7.png";

export const CONCEPT_IMAGES = {
  blockchain: { url: 'https://static.prod-images.emergentagent.com/jobs/2429ed2b-a893-4473-8b2e-2593750e3655/images/7b043d2e9b79144124afdc32e869afa02908f7ea1cf35e3978613afcf0503096.png', label: 'Blockchain' },
  nft: { url: 'https://static.prod-images.emergentagent.com/jobs/2429ed2b-a893-4473-8b2e-2593750e3655/images/b7e8a2eb1f71f6ecf7c099ceed893b33d3c2b164b32a811540d69a2319250e62.png', label: 'NFTs' },
  mining: { url: 'https://static.prod-images.emergentagent.com/jobs/2429ed2b-a893-4473-8b2e-2593750e3655/images/90b8c5a4e7cc6b8f09f8347b18ed94d727cd6d7e387db0930579af03652addc9.png', label: 'Mining' },
  wallet: { url: 'https://static.prod-images.emergentagent.com/jobs/2429ed2b-a893-4473-8b2e-2593750e3655/images/6ec73321fc0060ab936152b54265e8c9667524e5d9096056bcafebee705d4c8e.png', label: 'Wallet' },
  web3: { url: 'https://static.prod-images.emergentagent.com/jobs/2429ed2b-a893-4473-8b2e-2593750e3655/images/7c29409ac078b35ade64c823ba0b0dbab06af2efcd18cdb0e8aed553673899eb.png', label: 'Web3' },
  smart_contract: { url: 'https://static.prod-images.emergentagent.com/jobs/2429ed2b-a893-4473-8b2e-2593750e3655/images/83a59fa247f67751ecf5abd85fcae852fa5c63d99d933158cfb3a92cffa824ef.png', label: 'Smart Contracts' },
  token: { url: 'https://static.prod-images.emergentagent.com/jobs/2429ed2b-a893-4473-8b2e-2593750e3655/images/083d1715f391999e5453dbad2a4aefd7ed3217b6f35b578e1cff431bb8ae3206.png', label: 'Tokens' },
  metaverse: { url: 'https://static.prod-images.emergentagent.com/jobs/2429ed2b-a893-4473-8b2e-2593750e3655/images/7ac12e60667a60a94e30e70c71ac9a4ac36faf0fee3b33f3952283e02aafc283.png', label: 'Metaverse' },
};

export const detectConcept = (text) => {
  if (!text) return null;
  const q = text.toLowerCase();
  if (q.includes('smart contract')) return 'smart_contract';
  if (q.includes('web3') || q.includes('web 3')) return 'web3';
  for (const key of Object.keys(CONCEPT_IMAGES)) {
    if (key === 'smart_contract' || key === 'web3') continue;
    if (q.includes(key)) return key;
  }
  return null;
};

export const WEB3_KNOWLEDGE = {
  blockchain: "A blockchain is like a digital notebook that everyone shares! Once you write something in it, nobody can erase or change it. Every page (block) is chained to the last one.",
  bitcoin: "Bitcoin was the very first cryptocurrency! It was invented in 2009 by a mystery person called Satoshi Nakamoto. Think of it as digital gold.",
  mining: "Mining is when computers race to solve a super hard puzzle. The winner gets to add a new page to the blockchain notebook and earns crypto as a reward!",
  wallet: "A crypto wallet is like a digital piggy bank on your phone. It has a public address (like a mailbox) and a private key (the secret combination to open it).",
  nft: "An NFT is a one-of-a-kind digital certificate that proves YOU own something unique online \u2014 like a signed trading card that can't be faked!",
  token: "Tokens are like arcade coins, but digital! They can represent game points, a vote in a club, or even ownership of something cool.",
  gas: "Gas fees are tiny charges you pay to use the blockchain \u2014 like postage stamps. When lots of people are using it, stamps get more expensive!",
  smart_contract: "A smart contract is like a robot promise! It's code that automatically does things when conditions are met \u2014 like a vending machine for deals.",
  defi: "DeFi means banking without banks! People lend, borrow, and trade directly with each other using code \u2014 no bank manager needed.",
  web3: "Web3 is the next version of the internet where YOU own your stuff. Web1 = read, Web2 = read + write, Web3 = read + write + OWN!",
  consensus: "Consensus is when all computers in the network agree something is true \u2014 like the whole class voting 'Yep, that's correct!' before it's written down.",
  dao: "A DAO is a club where members vote on everything using tokens. No president or teacher \u2014 just rules in code that everyone follows!",
  staking: "Staking means locking up your crypto to help keep the blockchain running. In return, you earn rewards \u2014 like interest on a savings account!",
  metaverse: "The metaverse is a virtual world where you can hang out, play games, and own items. Like Roblox or Minecraft, but your stuff is truly yours!",
  airdrop: "An airdrop is when free tokens or NFTs are dropped into your wallet \u2014 like surprise candy showing up in your backpack!",
  private_key: "Your private key is a super-secret password for your wallet. NEVER share it \u2014 if someone gets it, they can take everything!",
  public_key: "Your public key is your wallet's address you CAN share \u2014 like your home address so friends can send you things.",
};

export const GAME_HINTS = {
  miners: [
    "Try placing blocks in the correct order \u2014 think about what a real blockchain looks like!",
    "Remember: each block needs to connect to the previous one. Check the hash values!",
    "Stuck on the puzzle? Look at the block colors \u2014 they give you clues about the right sequence.",
  ],
  wallet: [
    "Make sure to check your balance before sending tokens! Can't send what you don't have.",
    "The seed phrase is super important \u2014 try writing it down in the correct order.",
    "Watch out for phishing! Not every message is from a real friend in the game.",
  ],
  retro_arcade: [
    "Each level teaches a different Web3 concept. Pay attention to the intro screens!",
    "The leaderboard rewards speed AND accuracy \u2014 balance both for the best score!",
    "Found a hidden path? Some levels have secret areas with bonus knowledge tokens.",
  ],
  nft_studio: [
    "Your NFT is unique! Try different combinations of traits to create something special.",
    "The rarity of your NFT depends on which traits you pick \u2014 look for the star ratings!",
    "Don't forget to name your creation \u2014 every great NFT has a great story behind it.",
  ],
  mini_money: [
    "Gary the Goat needs help understanding why bartering is tricky \u2014 think about what's fair!",
    "Each era of money solves a problem from the last one. What problem does digital money solve?",
    "Collect all the history coins to unlock the bonus ending!",
  ],
};

export const HERO_STORIES = {
  gerry: {
    name: "Gerry",
    stories: [
      "What if Gerry the Goat accidentally discovered Bitcoin while looking for snacks? He'd probably try to eat the blockchain!",
      "Imagine Gerry starting his own cryptocurrency called GoatCoin. Every time someone bleats, they earn a token!",
      "Gerry once tried to explain mining to a sheep. The sheep just said 'baaaah' and walked away. Some things never change!",
    ],
  },
  zara: {
    name: "Zara",
    stories: [
      "What if Zara built an AI that could predict the next big crypto trend? She'd probably use it to fund a tech lab for kids!",
      "Zara once debugged a smart contract in her sleep. When she woke up, it had already processed 1,000 transactions!",
      "Imagine Zara creating a Web3 school where homework is submitted as NFTs. No more 'my dog ate it' excuses!",
    ],
  },
  sam: {
    name: "Sam",
    stories: [
      "What if Sam became a blockchain detective? He'd investigate every suspicious token with his magnifying glass emoji!",
      "Sam once refused to buy an NFT because he wanted to 'do more research.' Three months later, he wrote a 50-page report!",
      "Imagine Sam starting a Web3 fact-checking service. His catchphrase: 'Trust, but verify... on the blockchain!'",
    ],
  },
  miko: {
    name: "Miko",
    stories: [
      "What if Miko's digital art was the first NFT to be displayed in every metaverse gallery? The whole virtual world would be her canvas!",
      "Miko once drew a picture so beautiful that someone tried to right-click save it. The NFT guard dog barked them away!",
      "Imagine Miko creating an NFT collection where each piece changes based on the weather in the real world!",
    ],
  },
  ollie: {
    name: "Ollie",
    stories: [
      "What if Ollie created a play-to-earn game where you earn tokens by doing real homework? His grades would skyrocket!",
      "Ollie once speed-ran the entire BlockQuest Arcade in 12 minutes. Legend says his high score is still unbeaten!",
      "Imagine Ollie discovering a secret level in the blockchain that gives unlimited gaming tokens. He'd share them with everyone!",
    ],
  },
  lila: {
    name: "Lila",
    stories: [
      "What if Lila became the youngest DAO president? She'd make sure every kid gets a vote on what game to play next!",
      "Lila once organized a virtual bake sale using smart contracts. Every cookie was an NFT with a real recipe attached!",
      "Imagine Lila leading a Web3 summit where world leaders learn blockchain from teenagers. The future is NOW!",
    ],
  },
};

export const ENCOURAGEMENT = [
  "You're doing amazing! Every explorer starts somewhere.",
  "Keep going! The best blockchain builders never give up.",
  "Fun fact: even Satoshi Nakamoto had to learn step by step!",
  "You've got this! Gerry believes in you!",
  "Remember: making mistakes is how we learn. Try again!",
  "Baaaa-rilliant effort! You're getting smarter every minute!",
];

export const STUCK_TIPS = [
  "Looks like you might be stuck! Want me to explain the concept behind this level?",
  "Hey explorer! Need a hint? I've got plenty of Web3 wisdom to share!",
  "Gerry here! I noticed you've been on this part for a while. Want a quick tip?",
  "Don't worry \u2014 this part is tricky! Want me to break it down in simple terms?",
];

export const QUICK_ACTIONS = ['What is blockchain?', 'Tell me a story', 'Quiz me!', 'What is an NFT?'];

export const QUIZ_QUESTIONS = [
  // ─── Web3 Core ────────────────────────────────────────
  {
    category: 'web3',
    concept: 'blockchain',
    question: "What is a blockchain most like?",
    options: ["A shared digital notebook nobody can erase", "A secret file only banks can see", "A type of video game", "A social media app"],
    correct: 0
  },
  {
    category: 'web3',
    concept: 'bitcoin',
    question: "Who created Bitcoin?",
    options: ["Elon Musk", "Mark Zuckerberg", "Steve Jobs", "Satoshi Nakamoto"],
    correct: 3
  },
  {
    category: 'web3',
    concept: 'mining',
    question: "What do blockchain miners actually do?",
    options: ["Dig for real gold underground", "Build websites", "Race to solve puzzles and earn crypto", "Send emails to each other"],
    correct: 2
  },
  {
    category: 'web3',
    concept: 'wallet',
    question: "A crypto wallet's private key is:",
    options: ["Your email address", "Your phone number", "A type of cryptocurrency", "A super-secret password you should NEVER share"],
    correct: 3
  },
  {
    category: 'web3',
    concept: 'nft',
    question: "What makes an NFT special?",
    options: ["It can be copied easily", "It's free to create", "It proves YOU own something unique online", "It's only for adults"],
    correct: 2
  },
  {
    category: 'web3',
    concept: 'token',
    question: "Digital tokens are most like:",
    options: ["Computer viruses", "Digital arcade coins that represent different things", "Types of passwords", "Real coins you can hold"],
    correct: 1
  },
  {
    category: 'web3',
    concept: 'gas',
    question: "What are 'gas fees' on a blockchain?",
    options: ["Small charges to use the blockchain, like postage stamps", "Fees for buying real gas", "Monthly subscription costs", "Fines for breaking rules"],
    correct: 0
  },
  {
    category: 'web3',
    concept: 'smart_contract',
    question: "A smart contract is best described as:",
    options: ["A paper agreement", "A social media post", "Code that automatically runs when conditions are met", "A type of cryptocurrency"],
    correct: 2
  },
  {
    category: 'web3',
    concept: 'defi',
    question: "What does DeFi let people do?",
    options: ["Watch movies for free", "Play video games", "Lend, borrow and trade directly without banks", "Send text messages"],
    correct: 2
  },
  {
    category: 'web3',
    concept: 'web3',
    question: "What's the big deal about Web3?",
    options: ["Faster internet speed", "Free Wi-Fi everywhere", "Better video streaming", "You OWN your stuff online"],
    correct: 3
  },
  {
    category: 'web3',
    concept: 'consensus',
    question: "What is 'consensus' on a blockchain?",
    options: ["When one person decides everything", "A type of cryptocurrency", "When all computers in the network agree something is true", "A way to delete data"],
    correct: 2
  },
  {
    category: 'web3',
    concept: 'dao',
    question: "In a DAO, decisions are made by:",
    options: ["A single president", "Members voting with tokens using rules in code", "Random computers", "Social media polls"],
    correct: 1
  },
  {
    category: 'web3',
    concept: 'metaverse',
    question: "The metaverse is a virtual world where:",
    options: ["Nothing belongs to you", "You can hang out, play and truly own items", "Only adults are allowed", "Everything costs real money"],
    correct: 1
  },
  {
    category: 'web3',
    concept: 'airdrop',
    question: "A crypto airdrop is when:",
    options: ["You drop your phone", "Someone hacks your wallet", "Free tokens or NFTs appear in your wallet", "You lose all your crypto"],
    correct: 2
  },
  {
    category: 'web3',
    concept: 'staking',
    question: "What happens when you 'stake' crypto?",
    options: ["You lock it up to help the blockchain and earn rewards", "You lose it forever", "You send it to a friend", "You convert it to real money"],
    correct: 0
  },

  // ─── Geography + Web3 ─────────────────────────────────
  {
    category: 'geography',
    concept: 'blockchain',
    question: "El Salvador became the first country in the world to make Bitcoin legal money. Where is El Salvador?",
    options: ["Central America", "Europe", "Asia", "Africa"],
    correct: 0
  },
  {
    category: 'geography',
    concept: 'mining',
    question: "Iceland is a popular country for crypto mining because of its cold climate and cheap energy. What powers most of Iceland's electricity?",
    options: ["Coal and oil", "Solar panels", "Volcanoes and hot springs (geothermal)", "Nuclear power"],
    correct: 2
  },
  {
    category: 'geography',
    concept: 'web3',
    question: "The city-state of Singapore is known as a global crypto hub. Singapore is a tiny island nation in which part of the world?",
    options: ["South America", "Southeast Asia", "Northern Europe", "The Middle East"],
    correct: 1
  },
  {
    category: 'geography',
    concept: 'blockchain',
    question: "Switzerland's 'Crypto Valley' in the town of Zug is home to hundreds of blockchain companies. What famous mountain range is Switzerland known for?",
    options: ["The Andes", "The Himalayas", "The Alps", "The Rocky Mountains"],
    correct: 2
  },
  {
    category: 'geography',
    concept: 'nft',
    question: "NFT art has been sold worldwide, but which city hosted one of the first major NFT art auctions at Christie's auction house?",
    options: ["Tokyo, Japan", "New York, USA", "Sydney, Australia", "Cairo, Egypt"],
    correct: 1
  },
  {
    category: 'geography',
    concept: 'mining',
    question: "Before a government ban in 2021, which country had the most Bitcoin miners in the world?",
    options: ["Brazil", "India", "China", "Canada"],
    correct: 2
  },
  {
    category: 'geography',
    concept: 'token',
    question: "Nigeria in West Africa has one of the highest rates of crypto adoption among young people. Nigeria is located on which continent?",
    options: ["Asia", "South America", "Africa", "Europe"],
    correct: 2
  },
  {
    category: 'geography',
    concept: 'web3',
    question: "Dubai in the United Arab Emirates built a special 'free zone' for crypto companies. Dubai is famous for being located in which type of environment?",
    options: ["Tropical rainforest", "Arctic tundra", "Desert", "Volcanic island"],
    correct: 2
  },
  {
    category: 'geography',
    concept: 'blockchain',
    question: "Estonia, a small country by the Baltic Sea, was one of the first to put government records on a blockchain. Estonia is in which part of Europe?",
    options: ["Southern Europe", "Northern/Eastern Europe", "Western Europe", "An island off the coast"],
    correct: 1
  },
  {
    category: 'geography',
    concept: 'mining',
    question: "After China's mining ban, many Bitcoin miners moved to Texas in the USA. Why is Texas attractive for mining?",
    options: ["It's near the ocean", "It has cheap energy and lots of space", "It snows a lot there", "It's the smallest US state"],
    correct: 1
  },

  // ─── Science + Web3 ───────────────────────────────────
  {
    category: 'science',
    concept: 'blockchain',
    question: "Blockchain uses something called 'hashing' to lock data. A hash function always turns input into a fixed-size output. This is most like which science idea?",
    options: ["A fingerprint — unique to each person", "A telescope — makes things bigger", "A magnet — attracts metal", "A battery — stores energy"],
    correct: 0
  },
  {
    category: 'science',
    concept: 'mining',
    question: "Bitcoin mining uses a LOT of electricity. The energy used by the entire Bitcoin network is roughly equal to the energy use of which country?",
    options: ["A small town", "The entire country of Argentina", "Just one house", "A single school"],
    correct: 1
  },
  {
    category: 'science',
    concept: 'blockchain',
    question: "Blockchain relies on cryptography to keep data safe. The word 'cryptography' comes from Greek words meaning:",
    options: ["Fast writing", "Secret writing", "Loud writing", "Picture writing"],
    correct: 1
  },
  {
    category: 'science',
    concept: 'consensus',
    question: "Proof-of-Work mining requires computers to solve hard math puzzles. This uses so much power that some blockchains switched to Proof-of-Stake to save energy. What does 'conserving energy' mean in science?",
    options: ["Making more energy from nothing", "Using less energy to do the same job", "Turning energy into matter", "Storing energy in a blockchain"],
    correct: 1
  },
  {
    category: 'science',
    concept: 'blockchain',
    question: "A blockchain network is 'decentralized' — spread across many computers. In nature, which of these is also decentralized?",
    options: ["A king ruling a kingdom", "A school principal's office", "A colony of ants working together without a boss", "A traffic light controlling cars"],
    correct: 2
  },
  {
    category: 'science',
    concept: 'token',
    question: "Some crypto tokens are designed to be 'burned' (destroyed) to make the remaining ones more valuable. In chemistry, what happens when something is burned?",
    options: ["It freezes solid", "It combines with oxygen and releases energy", "It grows bigger", "It turns into a liquid"],
    correct: 1
  },
  {
    category: 'science',
    concept: 'wallet',
    question: "Crypto wallets use 'public' and 'private' keys made from very large prime numbers. In math, a prime number is a number that:",
    options: ["Is always even", "Can only be divided by 1 and itself", "Is always bigger than 100", "Ends in zero"],
    correct: 1
  },
  {
    category: 'science',
    concept: 'web3',
    question: "The internet that Web3 runs on sends data as tiny packets through fiber optic cables. Fiber optics use what to carry information?",
    options: ["Sound waves", "Water pressure", "Pulses of light", "Tiny robots"],
    correct: 2
  },
  {
    category: 'science',
    concept: 'nft',
    question: "NFTs prove ownership using math, not a physical stamp. In science, proof that can be checked by anyone and repeated is called:",
    options: ["A guess", "An opinion", "A verifiable result", "A secret"],
    correct: 2
  },
  {
    category: 'science',
    concept: 'smart_contract',
    question: "Smart contracts run automatically when conditions are met — like 'if temperature > 100, turn on fan.' In science, this is similar to a:",
    options: ["Hypothesis", "Feedback loop", "Random event", "Color spectrum"],
    correct: 1
  },

  // ─── History + Web3 ───────────────────────────────────
  {
    category: 'history',
    concept: 'bitcoin',
    question: "Bitcoin was launched in January 2009 during a major world event. What was happening in the global economy at that time?",
    options: ["A huge economic boom", "The Great Recession — banks were failing", "World War III", "The invention of the internet"],
    correct: 1
  },
  {
    category: 'history',
    concept: 'blockchain',
    question: "Before blockchain, people used physical ledgers (big books) to track money. The oldest known written records of trade come from which ancient civilization?",
    options: ["Ancient Rome", "Ancient Sumer (Mesopotamia)", "Medieval England", "Ancient Hawaii"],
    correct: 1
  },
  {
    category: 'history',
    concept: 'token',
    question: "Tokens and coins have been used for thousands of years. The first known metal coins were made around 600 BC in a kingdom called Lydia. Where was Lydia?",
    options: ["Modern-day Turkey", "Modern-day Brazil", "Modern-day Japan", "Modern-day Canada"],
    correct: 0
  },
  {
    category: 'history',
    concept: 'blockchain',
    question: "The idea of digital cash was tried many times before Bitcoin. In the 1990s, a computer scientist named David Chaum created 'DigiCash.' What decade was the World Wide Web invented?",
    options: ["1970s", "1980s", "1990s", "2000s"],
    correct: 1
  },
  {
    category: 'history',
    concept: 'nft',
    question: "NFTs prove digital ownership, but proving ownership of rare things is ancient. The Mona Lisa has been in the same museum since 1797. Which museum?",
    options: ["The British Museum", "The Louvre in Paris", "The Smithsonian", "The Guggenheim"],
    correct: 1
  },
  {
    category: 'history',
    concept: 'wallet',
    question: "Before crypto wallets, people kept gold in physical vaults. The largest gold vault in the world is under the Federal Reserve Bank in which city?",
    options: ["London", "Tokyo", "New York", "Dubai"],
    correct: 2
  },
  {
    category: 'history',
    concept: 'blockchain',
    question: "Cryptography (secret codes) has been used in wars for centuries. During World War II, which famous machine's codes were cracked by Alan Turing?",
    options: ["The Telegraph", "The Enigma Machine", "The Printing Press", "The Steam Engine"],
    correct: 1
  },
  {
    category: 'history',
    concept: 'smart_contract',
    question: "Smart contracts automate agreements. One of the earliest known legal codes in history was written by King Hammurabi of Babylon around 1750 BC. What were these laws carved into?",
    options: ["Paper scrolls", "A stone pillar (stele)", "Wooden tablets", "Animal skins"],
    correct: 1
  },
  {
    category: 'history',
    concept: 'defi',
    question: "DeFi removes the middleman from banking. The first known banks in history appeared during the Renaissance in which country?",
    options: ["France", "England", "Italy", "Spain"],
    correct: 2
  },
  {
    category: 'history',
    concept: 'web3',
    question: "Web3 is the third era of the internet. Web1 (read-only) started in 1991. Who is credited with inventing the World Wide Web?",
    options: ["Bill Gates", "Steve Jobs", "Tim Berners-Lee", "Mark Zuckerberg"],
    correct: 2
  },
];
